export const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

export const isAuthenticated = () => {
  return Boolean(getAuthToken());
};

export const logout = () => {
  localStorage.removeItem('authToken');
  window.location.href = '/';
};
